import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { AiOutlineClose } from "react-icons/ai";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import { formatDate } from "common/FunctionUtils";
const mainLogoNew = `/assets/fakt-logo.png`;

export const SalaryActions = ({ t, show, setShow, setLoading }) => {
  const [salarySlipData, setSalarySlipData] = useState({});
  const [additionalInvoiceCharges, setAdditionalInvoiceCharges] = useState([]);
  const [loadingReminder, setLoadingReminder] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const language = localStorage.getItem("i18nextLng");

  const handleDownloadPDF = () => {
    const element = document.getElementById("salary-modal");
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgWidth = 210;
        const pageHeight = 290;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jsPDF("p", "mm"); // eslint-disable-line new-cap
        let position = 0;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save("salary-details.pdf");
      });
    }
    setShow({ PDFModal: false, data: [], viewDetails: false });
  };


  const handleAdditionalInvoiceServiceFee = async (userId) => {
    try {
      setLoadingReminder(true);
      const res = await axios.get(`/AdditionalInvoiceServiceFee/${show?.id}/${userId}`);
      const invoiceData = res.data;

      setAdditionalInvoiceCharges(invoiceData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingReminder(false);
    }
  };

  const getBankDetails = (data) => {
    if (!data) return null;

    const isForeignBank = data?.userBank === "Foreign bank BIC / IBAN" || data?.userBank === "Revolut Bank";

    if (isForeignBank) {
      return {
        iban: data?.ibanNumber,
        bic: data?.bicNumber,
        account: null,
        clearing: null,
      };
    } else {
      return {
        iban: null,
        bic: null,
        account: data?.accountNumber,
        clearing: data?.clearingNumber,
      };
    }
  };

  const bankDetails = getBankDetails(salarySlipData);

  return (
    <Modal
      show={show.PDFModal || show.viewDetails}
      onHide={() => setShow({ PDFModal: false, viewDetails: false })}
      className="s-slip-modal"
    >
      <ModalHeader>
        {show.viewDetails ? t("SALARY DETAILS") : t("Download PDF")}.
        <AiOutlineClose
          size={25}
          onClick={() => setShow({ PDFModal: false, viewDetails: false })}
        />
      </ModalHeader>

      <ModalBody>
        <div id="salary-modal">
          <div className="page-content EconomyInvoices">
            <div
              className="invoice-details-container"
              style={{ paddingBottom: "5px" }}
            >
              <div className="invoice-details-part-container flex-column mt-1 w-100">
                <div className="invoice-details-wrapper-1">
                  <div className="invoice-details-row-container">
                    <div className="invoice-details-part-container w-100 f-culm">
                      <div className="invoice-details-row-column padding pl-4 pt-0">
                        <span className="invoice-details-title ml-3">
                          <img
                            className={`logo img-fluid`}
                            src={mainLogoNew}
                            alt="site-logo"
                            loading="lazy"
                          />
                        </span>
                      </div>

                      <div className="invoice-details-row-column padding salary-detail-popup">
                        <div className="invoice-details-row">
                          <p className="mb-3" style={{ color: "#535353" }}>
                            <strong>{t("Salary notice")}</strong>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="invoice-details-wrapper-1">
                  <div className="invoice-details-row-container">
                    <div className="invoice-details-part-container w-100 f-culm">
                      <div className="invoice-details-row-column padding"></div>

                      <div className="invoice-details-row-column padding">
                        <div className="invoice-details-row">
                          <p className="mb-2" style={{ color: "#535353" }}>
                            <strong>
                              {t(user?.firstName)} {t(user?.lastName)}{" "}
                            </strong>{" "}
                          </p>
                        </div>
                        <div className="invoice-details-row">
                          <p className="mb-2" style={{ color: "#535353" }}>
                            <strong>{t(user?.address)}</strong>{" "}
                          </p>
                        </div>
                        <div className="invoice-details-row">
                          <p className="mb-2" style={{ color: "#535353" }}>
                            <strong>
                              {t(user?.zipCode)} {t(user?.city)}
                            </strong>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <div className="d-flex align-items-center justify-content-between mt-1 p-2 employee-detail">
                  <div className="first">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center ">
                        <h6 className="m-0 font-weight-bold">
                          {t("Employee")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.userId}</p>
                      </div>

                      {salarySlipData?.userBank && (
                        <div className="customer-data d-flex align-items-center">
                          <h6 className="m-0 font-weight-bold">
                            {t("Bank details")}-&nbsp;
                          </h6>
                          <p className="m-0">
                            {/* {user?.customerSalaryInformation[0]?.accountNumber} */}
                          </p>
                        </div>
                      )}

                      <div>
                        {bankDetails?.iban && (
                          <>
                            <div className="d-flex align-items-center">
                              <h6 className="m-0 ">{t("IBAN")}:&nbsp;</h6>
                              <p className="m-0">{bankDetails?.iban}</p>
                            </div>
                            <div className="d-flex align-items-center">
                              <h6 className="m-0 ">{t("BIC")}:&nbsp;</h6>
                              <p className="m-0">{bankDetails?.bic}</p>
                            </div>
                          </>
                        )}
                        {bankDetails?.account && (
                          <>
                            <div className="d-flex align-items-center">
                              <h6 className="m-0">
                                {t("Account number:")}&nbsp;
                              </h6>
                              <p className="m-0">{bankDetails?.account}</p>
                            </div>

                            <div className="d-flex align-items-center">
                              <h6 className="m-0">
                                {t("Clearing number")}:&nbsp;
                              </h6>
                              <p className="m-0">{bankDetails?.clearing}</p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="second">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        {show?.salaryType === 2 ? (
                          <>
                            <h6 className="m-0 font-weight-bold">
                              {t("Holiday Payout Id")}:&nbsp;
                            </h6>

                            <p className="m-0">
                              {salarySlipData?.holidayPayoutId}
                            </p>
                          </>
                        ) : (
                          <>
                            <h6 className="m-0 font-weight-bold">
                              {t("Invoice Number")}:&nbsp;
                            </h6>

                            <p className="m-0">{salarySlipData?.invoice?.invoiceNumber ?? ''}</p>
                          </>
                        )}
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Payment Date")}:&nbsp;
                        </h6>

                        <p className="m-0">
                          {formatDate(
                            salarySlipData?.paidDate,
                            false,
                            language
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="salary-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">{t("Name")}</th>
                    <th scope="col">{t("From Date")}</th>
                    <th scope="col">{t("To Date")}</th>
                    <th scope="col">{t("Quantity Unit")}</th>
                    <th scope="col">{t("Amount")}</th>
                    <th scope="col">{t("Total")}</th>
                  </tr>
                </thead>
                <tbody>
                  {salarySlipData?.employeeSalaryHours?.map((item, index) => (
                    <tr key={index}>
                      <th scope="row">
                        {t(item?.description)}
                        <div> {item?.articleNumber}</div>
                      </th>
                      <td>-</td>
                      <td>-</td>
                      <td>1.00</td>
                      <td>{item?.amount}</td>
                      <td>{item?.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div
              style={{
                marginTop: "4px",
                marginBottom: "0px",
                padding: "30px",
              }}
            >
              <h3 className="font-weight-bold h5">
                {t("Salary calculation")}:
              </h3>

              <div>
                <div
                  className="deductionDetails"
                  style={{ alignItems: "center" }}
                >
                  {show?.salaryType === 2 ? (
                    <>
                      <p className="mb-1 h6" style={{ fontSize: "15px" }}>
                        {t("Holiday Pay Amount")}
                      </p>
                      <p className="m-0 ml-auto" style={{ fontSize: "15px" }}>
                        SEK {salarySlipData?.holidayPayoutTotalAmountRequested}
                      </p>
                    </>
                  ) : (
                    show?.salaryType !== 3 && (
                      <>
                        <p className="mb-1 h6" style={{ fontSize: "15px" }}>
                          {t("Invoice amount ex. VAT")}
                        </p>
                        <p className="m-0 ml-auto" style={{ fontSize: "15px" }}>
                          SEK {salarySlipData?.freelancerInvoiceAmount}
                        </p>
                      </>
                    )
                  )}
                </div>
                <div
                  className="deductionDetails bg-highlight"
                  style={{ alignItems: "center" }}
                >
                  {show?.salaryType === 2 ? (
                    <>
                      <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                        {t("Administrator Fee")}
                      </p>
                      <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                        SEK {salarySlipData?.holidayPayoutAdministratorFee}
                      </p>
                    </>
                  ) : (
                    show?.salaryType !== 3 && (
                      <>
                        <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                          {t("Invozio 0 percent fee")}
                        </p>
                        <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                          SEK {salarySlipData?.fakturaFee}
                        </p>
                      </>
                    )
                  )}
                </div>
                {show?.salaryType !== 2 && show?.salaryType !== 3 && (
                  <>
                    {salarySlipData?.invoice?.invoiceType == 3 && (
                      <div
                        className="deductionDetails"
                        style={{ alignItems: "center" }}
                      >
                        <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                          {t("Post Fee")}
                        </p>
                        <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                          SEK {salarySlipData?.totalPostFeeAmount}
                        </p>
                      </div>
                    )}
                    <div
                      className="deductionDetails"
                      style={{ alignItems: "center" }}
                    >
                      <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                        {t("Express Fee")}
                      </p>
                      <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                        SEK {salarySlipData?.expressFeeAmount}
                      </p>
                    </div>
                    <div
                      className="deductionDetails"
                      style={{ alignItems: "center" }}
                    >
                      <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                        {t("Holiday pay")}
                      </p>
                      <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                        SEK {salarySlipData?.holidaySavingsAmount}
                      </p>
                    </div>
                    <div
                      className="deductionDetails"
                      style={{ alignItems: "center" }}
                    >
                      <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                        {t("Social Fee")}
                      </p>
                      <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                        SEK {salarySlipData?.totalSocialFee}
                      </p>
                    </div>
                    <div className="">
                      {loadingReminder ? (
                        <p>Loading...</p>
                      ) : additionalInvoiceCharges.length > 0 ? (
                        <> {additionalInvoiceCharges.map((charge) => (
                          <div
                            className="deductionDetails"
                            style={{ alignItems: "center" }}
                          >
                            <p className="mb-1 h6" style={{ fontSize: "14px" }}>{charge.note}</p>
                            <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                              SEK {Number(charge.invoiceAmount).toFixed(2)}
                            </p>
                          </div>
                        ))}</>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                )}
                <div
                  className="deductionDetails"
                  style={{ alignItems: "center" }}
                >
                  <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                    {show?.salaryType === 2
                      ? t("Gross salary")
                      : t("Gross salary incl. holiday pay")}
                  </p>
                  <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                    SEK {salarySlipData?.grossSalary}
                  </p>
                </div>
                <div
                  className="deductionDetails"
                  style={{ alignItems: "center" }}
                >
                  <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                    {t("Tax")}
                  </p>
                  <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                    SEK {salarySlipData?.tax}
                  </p>
                </div>

                <div
                  className="deductionDetails"
                  style={{ alignItems: "center" }}
                >
                  <p className="mb-1 h6" style={{ fontSize: "14px" }}>
                    {t("Net salary incl. holiday pay")}
                  </p>
                  <p className="m-0 ml-auto" style={{ fontSize: "14px" }}>
                    SEK {salarySlipData?.amount}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mb-2" style={{ marginTop: "4px" }}>
              <div className="col salary-detail-one">
                <div className="d-flex align-items-center justify-content-between mt-1 p-2 tax-popup">
                  <div className="first">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center ">
                        <h6 className="m-0 font-weight-bold">
                          {t("Tax deduction")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.invoice?.tax}</p>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Preliminary employer's fee")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.totalSocialFee}</p>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("One-time tax basis")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.grossSalary}</p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Holidays Paid")}:&nbsp;
                        </h6>
                        <p className="m-0">
                          {salarySlipData?.holidaySavingsAmount}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="third">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Gross salary")}:&nbsp;
                        </h6>

                        <p className="m-0">{salarySlipData?.grossSalary}</p>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Preliminary tax")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.tax}</p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Tax-free expenses/deductions")}:&nbsp;
                        </h6>
                        <p className="m-0">
                          {salarySlipData?.taxFreeArticleAmount}
                        </p>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("To pay")}:&nbsp;
                        </h6>
                        <p className="m-0">{salarySlipData?.toPay}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col salary-detail-two">
                <div className="d-flex align-items-center justify-content-between mt-1 p-2 employee-detail">
                  <div className="first">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center ">
                        <h6 className="m-0 font-weight-bold">
                          {t("Address")}
                        </h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("Invozio LV SIA")}</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">AHTRI 12</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("10151  Tallinn")}&nbsp;</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("Estonia")}&nbsp;</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{"https://invozio.com"}&nbsp;</h6>
                      </div>
                    </div>
                  </div>
                  <div className="second">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">Phone</h6>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("010-264 88 10")}&nbsp;</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">{t("Email")}</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("support@invozio.com")}</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                              <h6 className="m-0">
                                {t("Payouts handled by Tallypro AB bank accounts")}
                              </h6>
                            </div>
                    </div>
                  </div>
                  <div className="second">
                    <div className="inner-group">
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Organization number")}
                        </h6>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("502085-4062")}</h6>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0 font-weight-bold">
                          {t("Vat Number")}
                        </h6>
                      </div>

                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("SE502085406201")}</h6>
                      </div>
                      <div className="customer-data d-flex align-items-center">
                        <h6 className="m-0">{t("Approved for F-tax")}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="salary">
        <button
          className="outline_btn_new close_SalaryNotice"
          onClick={() => setShow({ PDFModal: false, viewDetails: false })}
        >
          {show.viewDetails ? t("Close") : t("Cancel")}
        </button>

        <Button className="download_salry" onClick={() => handleDownloadPDF()}>
          {t("Download")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
